



import type { ProvenanceResponseData, ScansResponseData, Certificates } from './types'
import type { Action, Nullable } from '../model'
import type { CertificateAdmin } from 'types'

import { CertificatesActions } from './types'
import createReducer from '../createReducer'



export interface CertificatesReducer {
  certificates: Nullable<Certificates>
  certificate: Nullable<CertificateAdmin>
  certificateProvenance: Nullable<ProvenanceResponseData>
  certificateScans: Nullable<ScansResponseData>
}

const defaultState: CertificatesReducer = {
  certificates: null,
  certificate: null,
  certificateProvenance: null,
  certificateScans: null,
}

export const certificatesReducer = createReducer<CertificatesReducer>(defaultState, {
  [CertificatesActions.SET_CERTIFICATES]: (
    state: Nullable<CertificatesReducer>,
    action: Action<Nullable<Certificates>>
  ) => ({
    ...state,
    certificates: action.payload,
  }),

  [CertificatesActions.SET_CERTIFICATE]: (
    state: Nullable<CertificatesReducer>,
    action: Action<Nullable<CertificateAdmin>>
  ) => ({
    ...state,
    certificate: action.payload,
  }),

  [CertificatesActions.SET_CERTIFICATE_PROVENANCE]: (
    state: Nullable<CertificatesReducer>,
    action: Action<Nullable<ProvenanceResponseData>>
  ) => ({
    ...state,
    certificateProvenance: action.payload,
  }),

  [CertificatesActions.SET_CERTIFICATE_SCANS]: (
    state: Nullable<CertificatesReducer>,
    action: Action<Nullable<ScansResponseData>>
  ) => ({
    ...state,
    certificateScans: action.payload,
  }),
})
